<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="物料编码/名称">
              <el-input v-model="q.materialCode" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="链群">
              <el-input v-model="q.chainGroup" placeholder="请输入" clearable/>
            </el-form-item>
          </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" @click="handleAdd">新增</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table :data="tableData" ref="multipleTable" stripe border style="width: 100%" max-height="450">
          <el-table-column prop="materialCode" label="物料编码" width="120" show-overflow-tooltip/>
          <el-table-column prop="materialName" label="物料描述" min-width="180" show-overflow-tooltip/>
          <el-table-column prop="chainGroup" label="链群编码" width="100"/>
          <el-table-column prop="chainGroupName" label="链群名称" min-width="150"/>
          <el-table-column prop="purchaseRatio" label="采购占比" width="100"/>
          <el-table-column prop="chainRatio" label="链群占比" width="100"/>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" class="h-tableLink h-btn" @click="handleEdit(scope.row)">修改</el-button>
              <el-button type="text" class="h-tableLink h-btn" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableBL">
          <el-button class="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
        </div>
        <div class="h-pagination2">
          <pagination :page="q" @query="query"/>
        </div>
      </div>
    </div>

    <!--新增/修改弹窗-->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" class="h-dialog2 cost-config-dialog" width="650px" @close="cancelDialog">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{ isEdit ? '修改降成本物料占比' : '新增降成本物料占比' }}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="form" :rules="rules" ref="form" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
          <el-form-item label="物料编码" class="h-elformWrap-2" prop="materialCode">
            <el-input v-model="form.materialCode" placeholder="点击选择物料" readonly
                      @focus="openMaterialDialog" :disabled="isEdit"/>
          </el-form-item>
          <el-form-item label="物料描述" class="h-elformWrap-2">
            <el-input v-model="form.materialName" disabled/>
          </el-form-item>
          <el-form-item label="链群" class="h-elformWrap-2" prop="chainGroup">
            <el-input v-model="form.chainGroup" placeholder="请输入链群编码" clearable/>
          </el-form-item>
          <el-form-item label="链群名称" class="h-elformWrap-2">
            <el-input v-model="form.chainGroupName" placeholder="请输入链群名称" clearable/>
          </el-form-item>
          <el-form-item label="采购占比" class="h-elformWrap-2" prop="purchaseRatio">
            <el-input-number v-model="form.purchaseRatio" :min="0" :max="1" :precision="2" :step="0.1"
                             style="width:100%" @change="onPurchaseRatioChange"/>
          </el-form-item>
          <el-form-item label="链群占比" class="h-elformWrap-2">
            <el-input v-model="form.chainRatio" disabled/>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancelDialog">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!--物料选择弹窗-->
    <el-dialog :visible.sync="showMaterialDialog" title="选择物料" width="700px" append-to-body :close-on-click-modal="false">
      <el-form :inline="true">
        <el-form-item label="物料编码/名称">
          <el-input v-model="materialQ.keyword" placeholder="请输入" clearable @keyup.enter.native="searchMaterial"/>
        </el-form-item>
        <el-button class="h-btn h-formBtn" @click="searchMaterial">搜索</el-button>
      </el-form>
      <el-table :data="materialList" max-height="400" highlight-current-row>
        <el-table-column prop="prodcode" label="物料编码" width="120"/>
        <el-table-column prop="promodel" label="物料描述" min-width="200"/>
        <el-table-column prop="oneLid" label="链群编码" width="100"/>
        <el-table-column prop="prodseries" label="链群名称" width="150"/>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button type="text" @click="onMaterialRowClick(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;text-align:right">
        <paginationmin :page="materialQ" @query="searchMaterial"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import costMaterialConfig from "@/api/invoice/costMaterialConfig";
import updownfile from "@/utils/updownfile";

export default {
  data() {
    return {
      q: { materialCode: '', chainGroup: '', pageNo: 1, pageSize: 10, total: 0 },
      tableData: [],
      dialogVisible: false,
      showMaterialDialog: false,
      materialQ: { keyword: '', pageNo: 1, pageSize: 10, total: 0 },
      materialList: [],
      isEdit: false,
      form: {
        id: '', materialCode: '', materialName: '',
        chainGroup: '', chainGroupName: '',
        purchaseRatio: null, chainRatio: null
      },
      rules: {
        materialCode: [{ required: true, message: '请选择物料', trigger: 'change' }],
        chainGroup: [{ required: true, message: '请输入链群编码', trigger: 'blur' }],
        purchaseRatio: [{ required: true, message: '请输入采购占比', trigger: 'blur' }],
      },
    }
  },
  computed: {
    _user() { return this.$store.state.user; }
  },
  methods: {
    handleFilter() { this.q.pageNo = 1; this.query(); },
    resetData() {
      this.q = { materialCode: '', chainGroup: '', pageNo: 1, pageSize: 10, total: 0 };
      this.query();
    },
    query() {
      costMaterialConfig.selectPage(this.q).then(res => {
        this.tableData = res.records;
        this.q.total = res.total;
      });
    },
    handleAdd() {
      this.isEdit = false;
      this.form = { id: '', materialCode: '', materialName: '', chainGroup: '', chainGroupName: '', purchaseRatio: null, chainRatio: null };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleDelete(row) {
      this.$confirm('确定删除该配置吗？', '提示', { type: 'warning' }).then(() => {
        costMaterialConfig.deleteById(row.id).then(res => {
          if (res.f) { this.$message.success('删除成功'); this.query(); }
        });
      }).catch(() => {});
    },
    onPurchaseRatioChange(val) {
      if (val != null) {
        this.form.chainRatio = (1 - val).toFixed(2);
      }
    },
    openMaterialDialog() {
      this.materialQ = { keyword: '', pageNo: 1, pageSize: 10, total: 0 };
      this.showMaterialDialog = true;
      this._doSearchMaterial();
    },
    searchMaterial() {
      this.materialQ.pageNo = 1;
      this._doSearchMaterial();
    },
    _doSearchMaterial() {
      costMaterialConfig.selectMaterialList(this.materialQ).then(res => {
        this.materialList = res.records || [];
        this.materialQ.total = res.total || 0;
      });
    },
    onMaterialRowClick(row) {
      this.form.materialCode = row.prodcode || '';
      this.form.materialName = row.promodel || '';
      this.form.chainGroup = row.oneLid || '';
      this.form.chainGroupName = row.prodseries || '';
      this.showMaterialDialog = false;
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const api = this.isEdit ? 'updateById' : 'insert';
        costMaterialConfig[api](this.form).then(res => {
          if (res.f) {
            this.$message.success(this.isEdit ? '修改成功' : '新增成功');
            this.dialogVisible = false;
            this.query();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      });
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.$refs.form && this.$refs.form.resetFields();
    },
    exportExcel() {
      let params = { ...this.q };
      updownfile.down(costMaterialConfig.baseurl + '/downloadExcel', params, "get");
    },
  },
  created() { this.query(); },
  activated() { this.query(); },
}
</script>
<style lang="less" scoped>
</style>
<style lang="less">
.cost-config-dialog .h-dialogImg {
  background-size: cover;
}
</style>
